import React from 'react'
import { Modal } from 'react-bootstrap'
import './SelectContactStyle.css'
import '../ModalStyle.css'
import { IContact } from '@dataTypes/contact.type'
import { useAppDispatch } from '@store/hooks'
import { SET_INPUT_NUMBER } from '@store/reducers/messageCenter.reducer'
import { preferredCallMethodOptions } from '@constants/Message'
import {
  formatPhoneNumber,
  normalizePhoneNumber,
} from '@utils/numberFormatter.util'
import { setActiveSidePanel } from '@store/reducers/uiSlice.reducer'

type SelectContactModalProps = {
  show: boolean
  onHide: () => void
  contactData: IContact
  backdropClassName?: string
  customClassName?: string
}

const SelectContactModal: React.FC<SelectContactModalProps> = ({
  show,
  onHide,
  contactData,
  backdropClassName,
  customClassName,
}) => {
  const dispatch = useAppDispatch()
  const onClick = (contactNumber: string): void => {
    dispatch(SET_INPUT_NUMBER(normalizePhoneNumber(contactNumber)))
    dispatch(setActiveSidePanel('phone'))
    onHide()
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className={['select-contact-modal', customClassName]
        .filter(Boolean)
        .join(' ')}
      backdropClassName={backdropClassName}
      backdrop="static"
    >
      <Modal.Header closeButton className="select-contact-modal-header">
        <Modal.Title>Select a contact number</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {preferredCallMethodOptions.map((label) => {
          const value = contactData[label.id as keyof IContact] as string

          if (value) {
            return (
              <button
                type="button"
                key={label.id}
                className="unstyled-button contact-item"
                onClick={() => onClick(value)}
              >
                <span className="scm-contact-info">
                  <span className="scm-dn-number">
                    {formatPhoneNumber(value)}
                  </span>
                  <span className="scm-label">{label.text}</span>
                </span>
                {label.id === contactData.preferred_call_method ? (
                  <span className="scm-dn-preferred">Preferred</span>
                ) : null}
              </button>
            )
          }
          return null
        })}
      </Modal.Body>
    </Modal>
  )
}

export default SelectContactModal
